import React from 'react';

import { useModalStore } from '@/store/apps/modalStore';

type Props = {
  id: string;
  closeOnClickOutside: boolean;
};

export default function Overlay({ id, closeOnClickOutside }: Props) {
  const { closeModal } = useModalStore();
  return (
    <button
      type="button"
      aria-label="모달 닫기"
      disabled={!closeOnClickOutside}
      className="fixed left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 bg-black/60"
      onClick={() => {
        if (closeOnClickOutside) closeModal(id);
      }}
    />
  );
}
